import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';


const sidemenuDefaultState = {
  wide: true,
};

export default makeSettingsReducer('sidemenu', sidemenuDefaultState);
